import React, { useState, useEffect } from 'react';
import axios from '../../Authservices/axiosInstance';
import { FaBuilding, FaPencilAlt, FaTrashAlt, FaInfoCircle } from 'react-icons/fa';
import { IoMdAddCircle } from 'react-icons/io';
import { Row, Col, Button, Form, Dropdown, Modal, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './departments.css';

export default function DepartmentTable() {
  const [departments, setDepartments] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [departmentToDelete, setDepartmentToDelete] = useState(null);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const response = await axios.get(
          `https://backend.ems.uk.hiradentallab.com/api/departments?search=${searchQuery}`
        );
        setDepartments(response.data);
      } catch (error) {
        console.error('Error fetching departments:', error);
        setShowErrorAlert(true);
        setErrorMessage('Error fetching departments. Please try again.');
        hideAlertAfterDelay(setShowErrorAlert); // Handle alert timeout
      }
    };

    fetchDepartments();

    document.body.style.overflowY = 'auto';
    return () => {
      document.body.style.overflowY = '';
    };
  }, [searchQuery]); // Refetch data whenever searchQuery changes


  const handleSearch = (e) => {
    e.preventDefault(); // Disable default form behavior
    setSearchQuery(e.target.value); // Update search query
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleDelete = (id) => {
    setDepartmentToDelete(id);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    try {
      await axios.delete(`https://backend.ems.uk.hiradentallab.com/api/departments/delete/${departmentToDelete}`);
      setShowSuccessAlert(true);
      setDepartments(departments.filter(department => department._id !== departmentToDelete));
      hideAlertAfterDelay(setShowSuccessAlert);  // Set timer for success alert
    } catch (error) {
      console.error('Error deleting department:', error);
      setShowErrorAlert(true);
      setErrorMessage('Failed to delete department. Please try again.');
      hideAlertAfterDelay(setShowErrorAlert);  // Set timer for error alert
    } finally {
      setShowDeleteModal(false);
    }
  };

  const hideAlertAfterDelay = (setAlertFunction) => {
    setTimeout(() => {
      setAlertFunction(false);
    }, 3000);  // Hide alert after 3 seconds
  };

  const pageRange = () => {
    const totalPages = Math.ceil(departments.length / rowsPerPage);
    return Array.from({ length: totalPages }, (_, index) => index + 1);
  };

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = departments.slice(indexOfFirstRow, indexOfLastRow);
  const totalEntries = departments.length;

  return (
    <div className='container-fluid'>
      <h1 className="department-title">
        <FaInfoCircle className="salary-icon" /> Departments Information
      </h1>
      <hr />
      <h2 className="department-subtitle">
        <FaBuilding className="salary-icon" /> All Departments
      </h2>
      <hr />


        {/* Success and Error Alerts */}
        {showSuccessAlert && (
          <Alert variant="success" onClose={() => setShowSuccessAlert(false)} dismissible>
            Department deleted successfully!
          </Alert>
        )}
        {showErrorAlert && (
          <Alert variant="danger" onClose={() => setShowErrorAlert(false)} dismissible>
            {errorMessage}
          </Alert>
        )}

      <div className="table-container">
        <Link to="/add-departments" style={{ textDecoration: 'none' }}>
          <Button variant="primary" style={{ marginBottom: '1%', marginLeft: '7px' }}>
            <IoMdAddCircle /> Add Department
          </Button>
        </Link>

        <div className="filter-container">
          <Col xs={12} md={6} className="filter-left">
            <Dropdown className="d-inline mx-2" autoClose="inside">
              <Dropdown.Toggle id="dropdown-autoclose-inside">
                Show Entries
              </Dropdown.Toggle>
              <Dropdown.Menu className="custom-dropdown-menu">
                <Dropdown.Item href="#">15</Dropdown.Item>
                <Dropdown.Item href="#">25</Dropdown.Item>
                <Dropdown.Item href="#">50</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Col>
          <Col xs={12} md={6} className="filter-right">
        <Form className="d-flex">
          <Form.Control
            type="search"
            placeholder="Search"
            aria-label="Search"
            className="depts-search-bar"
            value={searchQuery}
            onChange={handleSearch} // Update search query dynamically
          />
        </Form>
      </Col>
        </div>

        <div>
          <section>
            <div id="main-box">
              <div className="depts-table-responsive">
                <table className="table table-striped table-style table-sm">
                  <thead>
                    <tr role="row">
                      <th style={{ backgroundColor: '#007bff', color: '#ffffff' }}>SR</th>
                      <th style={{ backgroundColor: '#007bff', color: '#ffffff' }}>Department</th>
                      <th style={{ textAlign: 'center', backgroundColor: '#007bff', color: '#ffffff' }}>Action</th>
                    </tr>
                  </thead>
                  <tbody className="department-table">
                    {currentRows.map((department, index) => (
                      <tr role="row" className={index % 2 === 0 ? 'even' : 'odd'} key={department._id}>
                        <td>{index + 1 + indexOfFirstRow}</td>
                        <td>{department.name}</td>
                        <td style={{ textAlign: 'center' }}>
                          <Link to={`/edit-departments/${department._id}`}>
                            <Button size="sm" className="btn btn-warning my-1">
                              <FaPencilAlt />
                            </Button>
                          </Link>
                          <Button
                            type="button"
                            name="delete"
                            size="sm"
                            className="btn btn-danger my-1"
                            onClick={() => handleDelete(department._id)}
                          >
                            <FaTrashAlt />
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot className="table-footer">
                    <tr className="departments-table-footer">
                      <td>Total</td>
                      <td>-</td>
                      <td>{totalEntries}</td>
                    </tr>
                  </tfoot>
                </table>

                <Row className="mt-2">
                  <Col xs={12} md={6} className="d-flex align-items-center">
                    <p className="showing-entries">
                      Showing {(currentPage - 1) * rowsPerPage + 1} to {Math.min(currentPage * rowsPerPage, totalEntries)} of {totalEntries} entries
                    </p>
                  </Col>
                  <Col xs={12} md={6} className="d-flex justify-content-end">
                    <nav>
                      <ul className="pagination">
                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                          <a
                            href="/#"
                            className="page-link"
                            onClick={(e) => {
                              e.preventDefault();
                              handlePageChange(currentPage - 1);
                            }}
                          >
                            Previous
                          </a>
                        </li>
                        {pageRange().map((page) => (
                          <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                            <a
                              href="/#"
                              className="page-link"
                              onClick={(e) => {
                                e.preventDefault();
                                handlePageChange(page);
                              }}
                            >
                              {page}
                            </a>
                          </li>
                        ))}
                        <li className={`page-item ${currentPage === Math.ceil(totalEntries / rowsPerPage) ? 'disabled' : ''}`}>
                          <a
                            href="/#"
                            className="page-link"
                            onClick={(e) => {
                              e.preventDefault();
                              handlePageChange(currentPage + 1);
                            }}
                          >
                            Next
                          </a>
                        </li>
                      </ul>
                    </nav>
                  </Col>
                </Row>
              </div>
            </div>
          </section>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete this department?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={confirmDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

    </div>
  );
}
